export default "__VITE_ASSET__h3isl7j8__"